var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-wrap" }, [
    _c("div", { staticClass: "w-full md:pl-10 md:w-3/4 md:pr-20" }, [
      _vm.allowThirdParty
        ? _c("div", { staticClass: "mb-5" }, [
            _c("h1", { staticClass: "mb-4 font-sans-bold" }, [
              _vm._v("Ticketing"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-5" }, [
              _vm._v(
                "\n        Reimagine has agreed to make an exception for you to use a third-party ticketing vendor for your event. Please provide a fully qualified URL to link out to your ticketing page (must include http:// or https:// – e.g., https://letsreimagine.org).\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "label",
              { ref: "thirdPartyUrl", attrs: { for: "thirdPartyUrl" } },
              [
                _vm._v("\n        Ticket URL\n        "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "flex-grow" }, [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: true, url: { require_tld: true } },
                      expression:
                        "{ required: true, url: { require_tld: true }}",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.thirdPartyUrl,
                      expression: "form.thirdPartyUrl",
                    },
                  ],
                  attrs: {
                    id: "thirdPartyUrl",
                    type: "text",
                    name: "thirdPartyUrl",
                  },
                  domProps: { value: _vm.form.thirdPartyUrl },
                  on: {
                    keyup: function ($event) {
                      return _vm.filterUrl(_vm.form.thirdPartyUrl)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "thirdPartyUrl", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "inline-flex px-2 text-white no-underline bg-black md:px-8",
                  attrs: {
                    href: `https://${_vm.form.thirdPartyUrl}`,
                    target: "_blank",
                  },
                },
                [
                  _c("span", { staticClass: "self-center uppercase" }, [
                    _vm._v("Test Link"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("thirdPartyUrl"),
                    expression: "errors.has('thirdPartyUrl')",
                  },
                ],
                staticClass: "text-lg error text-error-red",
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.errors.first("thirdPartyUrl")) +
                    "\n      "
                ),
              ]
            ),
          ])
        : _c(
            "div",
            [
              _c("h1", { staticClass: "mb-4" }, [_vm._v("Ticketing")]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-12" },
                [
                  _c("label", { ref: "price", attrs: { for: "price" } }, [
                    _vm._v(
                      "\n          General Admission Price (USD)\n          "
                    ),
                    _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _vm._m(2),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.form.tickets, function (ticket, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "flex items-center border-b border-gray-medium pb-5 mb-5",
                        attrs: { name: "name" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "font-bold text-lg w-48 lg:w-68 pr-5",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: ticket.name,
                                  expression: "ticket.name",
                                },
                              ],
                              staticClass: "flex-1 short-input",
                              attrs: { id: "name", type: "text", name: "name" },
                              domProps: { value: ticket.name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(ticket, "name", $event.target.value)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|numeric",
                              expression: "'required|numeric'",
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: ticket.price,
                              expression: "ticket.price",
                            },
                          ],
                          staticClass: "flex-1 short-input",
                          attrs: { id: "price", type: "text", name: "price" },
                          domProps: { value: ticket.price },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(ticket, "price", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.form.tickets.length > 1
                          ? _c(
                              "button",
                              {
                                staticClass: "pl-3",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.removeTicketOption(index)
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass:
                                      "svg-inline--fa fa-trash-alt fa-w-14 w-3",
                                    attrs: {
                                      "aria-hidden": "true",
                                      focusable: "false",
                                      "data-prefix": "fas",
                                      "data-icon": "trash-alt",
                                      role: "img",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 448 512",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        fill: "currentColor",
                                        d: "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("name"),
                          expression: "errors.has('name')",
                        },
                      ],
                      staticClass: "text-lg error text-error-red",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.errors.first("name")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("price"),
                          expression: "errors.has('price')",
                        },
                      ],
                      staticClass: "text-lg error text-error-red",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.errors.first("price")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.form.tickets.length < 4
                    ? _c(
                        "button",
                        {
                          staticClass: "button mt-3",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.addTicketOptions.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.ticketOptionsButton) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mb-12" }, [
                _c("label", { ref: "amount", attrs: { for: "amount" } }, [
                  _vm._v("\n          Event Capacity\n          "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "block text-sm font-sans-book" }, [
                    _vm._v(
                      "\n            This is the maximum number of tickets to be sold. If your event does not have a maximum capacity, please enter 9999 in this field.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|numeric",
                      expression: "'required|numeric'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.maxTickets,
                      expression: "form.maxTickets",
                    },
                  ],
                  attrs: { id: "amount", type: "text", name: "amount" },
                  domProps: { value: _vm.form.maxTickets },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "maxTickets", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("amount"),
                        expression: "errors.has('amount')",
                      },
                    ],
                    staticClass: "text-lg error text-error-red",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.errors.first("amount")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.hasPaidTicketOption
                ? [
                    _c(
                      "div",
                      { staticClass: "mb-12" },
                      [
                        _c("label", [
                          _vm._v(
                            "How would you like to receive payment from ticket sales?"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("RadioGroup", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: {
                            name: "paymentMethod",
                            options: _vm.paymentMethods,
                          },
                          model: {
                            value: _vm.form.paymentMethod,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "paymentMethod", $$v)
                            },
                            expression: "form.paymentMethod",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("paymentMethod"),
                                expression: "errors.has('paymentMethod')",
                              },
                            ],
                            staticClass: "text-lg error text-error-red",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.errors.first("paymentMethod")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.paymentMethod
                      ? _c("div", { staticClass: "mb-12" }, [
                          _c("label", { attrs: { for: "paymentDetails" } }, [
                            _vm._v(_vm._s(_vm.paymentDetailsLabel)),
                          ]),
                          _vm._v(" "),
                          _vm.form.paymentMethod !== "check"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.paymentDetails,
                                    expression: "form.paymentDetails",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  id: "paymentDetails",
                                  name: "paymentDetails",
                                  type: "text",
                                },
                                domProps: { value: _vm.form.paymentDetails },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.form,
                                      "paymentDetails",
                                      $event.target.value
                                    )
                                  },
                                },
                              })
                            : _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.paymentDetails,
                                    expression: "form.paymentDetails",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  id: "paymentDetails",
                                  name: "paymentDetails",
                                },
                                domProps: { value: _vm.form.paymentDetails },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.form,
                                      "paymentDetails",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("paymentDetails"),
                                  expression: "errors.has('paymentDetails')",
                                },
                              ],
                              staticClass: "text-lg error text-error-red",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.errors.first("paymentDetails")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
      _vm._v(" "),
      _c("div", { staticClass: "flex md:flex-no-wrap flex-wrap" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { "opacity-50 cursor-not-allowed": _vm.saving },
            attrs: { disabled: _vm.saving },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.save.apply(null, arguments)
              },
            },
          },
          [_vm.saving ? [_vm._v("Processing...")] : [_vm._v("Save")]],
          2
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "mr-0 md:mr-4 mb-4 md:mb-4 w-full md:w-auto",
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { "opacity-50 cursor-not-allowed": _vm.saving },
            attrs: { disabled: _vm.saving },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.saveNext.apply(null, arguments)
              },
            },
          },
          [_vm._v("Save & Next")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "w-full pt-3 mt-10 border-black md:w-1/4 md:mt-2",
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "inline-flex flex-initial px-4 border-t border-b border-l border-black bg-gray-hr",
      },
      [_c("span", { staticClass: "self-center" }, [_vm._v("http(s)://")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-5" }, [
      _vm._v(
        "\n        We partner with SquadUP to power our ticketing system. Please review SquadUP's "
      ),
      _c(
        "a",
        { attrs: { href: "https://www.squadup.com/tos", target: "_blank" } },
        [_vm._v("Terms of Service")]
      ),
      _vm._v(" and "),
      _c(
        "a",
        { attrs: { href: "https://www.squadup.com/faq", target: "_blank" } },
        [_vm._v("FAQ")]
      ),
      _vm._v(".\n      "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "block text-sm font-sans-book border-b border-gray-medium pb-5 mb-5",
      },
      [
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            "\n              If you are hosting a paid event, please enter the General Admission (GA) ticket price (whole number, no dollar sign, e.g. 10). If you are hosting a free event, please enter the number 0 in this field.\n            "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            '\n              You can also rename the ticketing options by clicking on the text (e.g. "Option 1") and typing in a new label name (e.g. "Free").\n            '
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }